import { render, staticRenderFns } from "./index-v2.vue?vue&type=template&id=7443764e&"
import script from "./index-v2.vue?vue&type=script&lang=js&"
export * from "./index-v2.vue?vue&type=script&lang=js&"
import style0 from "./index-v2.vue?vue&type=style&index=0&id=7443764e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports